import { observer } from "mobx-react-lite";
import React, { ReactElement } from "react";
import { Card, Divider, Grid, Progress, Image, Label } from "semantic-ui-react";
import { IAssessment } from "../../../../Models/Assessment";
import { IRecipientModel } from "../../../../Models/Recipient";
import styles from "./ScoreMemberCard.module.css";

export interface IScoreMemberCardProps {
  icon: string;
  percentComplete: number;
  title: string;
  selectedRecipient: IRecipientModel;
  videoLink: string;
  overviewTitle: string;
  overviewBody?: ReactElement<any, any>;
  assessment: IAssessment;
  tasks: string[];
  setModVisible: () => void;
  setAssessmentVisible: () => void;
}
const ScoreMemberCard: React.FC<IScoreMemberCardProps> = ({
  icon,
  percentComplete,
  title,
  setModVisible,
  setAssessmentVisible,
}) => {
  const getButtonFromPercentComplete = (percentComplete: number) => {
    if (percentComplete === 0) {
      return (
        <button className={styles.buttonStyle} onClick={setModVisible}>
          Start Tasks
        </button>
      );
    } else if (percentComplete === 100) {
      return (
        <button onClick={setModVisible} className={styles.buttonStyle}>
          Review Tasks
        </button>
      );
    } else {
      return (
        <button onClick={setAssessmentVisible} className={styles.buttonStyle}>
          Continue Tasks
        </button>
      );
    }
  };

  return (
    <>
      <Grid.Column
        style={{
          display: "flex",
        }}
      >
        <Card data-testid="member-card" className={styles.memberCard} style={{ width: '100%' }}>
          <Card.Content>
            <div style={{ paddingTop: "25px" }}>
              <Card.Description
                style={{
                  fontSize: 17,
                  color: "#333",
                  fontWeight: "800",
                  height: 25
                }}
              >
                <Image
                  src={icon}
                  size="mini"
                  style={{ paddingRight: "10px" }}
                />
                {title}
              </Card.Description>
              <Progress percent={percentComplete} color="teal" />
              <Label color="teal" circular style={{ marginTop: -15 }}>{percentComplete} %</Label>
              <Divider />
              <Card.Description className={styles.buttonSection}>
                {getButtonFromPercentComplete(percentComplete)}
              </Card.Description>
            </div>
          </Card.Content>
        </Card>
      </Grid.Column>
    </>
  );
};

export default observer(ScoreMemberCard);
